import {Component, OnInit, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {jqxGridComponent} from '../../../../assets/jqwidgets-ts/angular_jqxgrid';
import {_GridService} from '../../../ng1-services/grid.service';

import {Grid} from '../../../interfaces/grid.interface';
import {_RuleNettingPriorityService} from "../../../services/ruleNettingPriority.service";

declare var $: any, dump: any;

@Component({
  selector: 'netting',
  templateUrl: './netting.component.html',
  styleUrls: ['./netting.component.css'],
})

export class NettingBranch implements OnInit {

  @ViewChild('currencyPairPriorityGrid') currencyPairPriorityGrid: jqxGridComponent;
  @ViewChild('currencyPriorityGrid') currencyPriorityGrid: jqxGridComponent;

  //grid settings
  private currencyPairPrioritySettings: Grid;
  private currencyPrioritySettings: Grid;

  private currencyPairValueList: any;
  private currencyValueList: any;

  constructor(private titleService: Title, private ruleNettingPriorityService: _RuleNettingPriorityService, private gridService: _GridService) { }

  ngOnInit() {
    this.titleService.setTitle("WiseRisk | Targets and Netting Rules");

    //Load Grids
    this.loadCurrencyPairPriorities();
    this.loadCurrencyPriorities();
  }

  loadCurrencyPairPriorities() {
    this.currencyPairPrioritySettings = null;
    this.ruleNettingPriorityService.getNettingPriorities('CURRENCY_PAIR_PRIORITY').then((data) => {
      var msgContainer = "currencyPairPriorityMsg";
      this.currencyPairValueList = {};
      var source = {
        datatype: 'json',
        localdata: data,
        datafields: [{
            name: 'ruleNettingPriorityId',
            type: 'int'
          }, {
            name: 'organizationId',
            type: 'int'
          }, {
            name: 'ruleType',
            type: 'string'
          }, {
            name: 'priority',
            type: 'int'
          }, {
            name: 'priorityValues',
            type: 'string'
          }
        ],
        updaterow: (rowid, rowdata, commit) => {
          rowdata.ruleType = "CURRENCY_PAIR_PRIORITY";
          rowdata.priorityValues = this.currencyPairValueList[rowid];
          //New Row
          if (rowdata.rowId < 1) {
            this.ruleNettingPriorityService.createNettingPriority(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Currency Pair Priority Added');
              this.loadCurrencyPairPriorities();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          } else {
            this.ruleNettingPriorityService.updateNettingPriority(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Currency Pair Priority Updated');
              this.loadCurrencyPairPriorities();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }
        },
        deleterow: (rowdata) => {
          this.ruleNettingPriorityService.deleteNettingPriority(rowdata.ruleNettingPriorityId).toPromise().then((data) => {
            this.gridService.SuccessMsg(msgContainer, 'Currency Pair Priority Deleted');
            this.loadCurrencyPairPriorities();
          }, (data) => {
            this.gridService.ErrorMsg(msgContainer, data);
          });
        },
        refresh: () => {
          this.loadCurrencyPairPriorities();
        },
        getGrid: () => {
          return this.currencyPairPriorityGrid;
        }
      };

      this.currencyPairPrioritySettings = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [
          {
            text: 'Priority',
            columntype: 'textbox',
            datafield: 'priority',
            width: '80',
          }, {
            text: 'Ccy Pairs',
            columntype: 'dropdownlist',
            datafield: 'priorityValues',
            width: '500',
            createeditor: (row, cellvalue, editor) => {
              editor.jqxDropDownList({
                checkboxes: true,
                source: this.gridService.GetCurrencyPairDataAdapter(false),
                displayMember: "currencyPair",
                valueMember: "currencyPair"
              });
            },
            initeditor: (rowid, cellvalue, editor, celltext, cellwidth, cellheight) => {
              var items = editor.jqxDropDownList('getItems');
              editor.jqxDropDownList('uncheckAll');
              var values = cellvalue ? cellvalue.split(/,\s*/) : [];
              for (var j = 0; j < values.length; j++) {
                for (var i = 0; i < items.length; i++) {
                  if (items[i].label === values[j]) {
                    editor.jqxDropDownList('checkIndex', i);
                  }
                }
              }
              editor.on('close', (event) => {
                var items = editor.jqxDropDownList('getCheckedItems');
                var itemsLabel = '';
                for (var i = 0; i < items.length; i++) {
                  if (!itemsLabel) {
                    itemsLabel = items[i].value;
                  } else {
                    itemsLabel += ',' + items[i].value;
                  }
                }
                //this.currencyPairPriorityGrid.setcellvalue(rowid, 'priorityValues', itemsLabel);
                this.currencyPairValueList[rowid] = itemsLabel;
              });
            }
          }
        ],
        renderstatusbar: (statusbar: any) => {
          this.gridService.RenderStatusBar(statusbar, source);
        }
      };
    });
  }

  loadCurrencyPriorities() {
    this.currencyPrioritySettings = null;
    this.ruleNettingPriorityService.getNettingPriorities('CURRENCY_PRIORITY').then(data => {
      var msgContainer = "currencyPriorityMsg";
      this.currencyValueList = {};
      var source = {
        localdata: data,
        datafields: [{
            name: 'ruleNettingPriorityId',
            type: 'int'
          }, {
            name: 'organizationId',
            type: 'int'
          }, {
            name: 'ruleType',
            type: 'string'
          }, {
            name: 'priority',
            type: 'int'
          }, {
            name: 'priorityValues',
            type: 'string'
          }
        ],
        updaterow: (rowid, rowdata, commit) => {
          rowdata.ruleType = "CURRENCY_PRIORITY";
          rowdata.priorityValues = this.currencyValueList[rowid];
          //New Row
          if (rowdata.rowId < 1) {
            this.ruleNettingPriorityService.createNettingPriority(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Currency Priority Added');
              this.loadCurrencyPriorities();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          } else {
            this.ruleNettingPriorityService.updateNettingPriority(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Currency Priority Updated');
              this.loadCurrencyPriorities();
            }, (data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }
        },
        deleterow: (rowdata) => {
          this.ruleNettingPriorityService.deleteNettingPriority(rowdata.ruleNettingPriorityId).toPromise().then((data) => {
            this.gridService.SuccessMsg(msgContainer, 'Currency Priority Deleted');
            this.loadCurrencyPriorities();
          }, (data) => {
            this.gridService.ErrorMsg(msgContainer, data);
          });
        },
        refresh: () => {
          this.loadCurrencyPriorities();
        },
        getGrid: () => {
          return this.currencyPriorityGrid;
        }
      };
      this.currencyPrioritySettings = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [{
          text: 'Priority',
          columntype: 'textbox',
          datafield: 'priority',
          width: '80',
        }, {
            text: 'Currency',
            columntype: 'dropdownlist',
            datafield: 'priorityValues',
            width: '500',
            createeditor: (row, cellvalue, editor) => {
              editor.jqxDropDownList({
                checkboxes: true,
                source: this.gridService.GetCurrencyDataAdapter(false, false),
                displayMember: "currency",
                valueMember: "currency"
              });
            },
            initeditor: (rowid, cellvalue, editor, celltext, cellwidth, cellheight) => {
              var items = editor.jqxDropDownList('getItems');
              editor.jqxDropDownList('uncheckAll');
              var values = cellvalue ? cellvalue.split(/,\s*/) : [];
              for (var j = 0; j < values.length; j++) {
                for (var i = 0; i < items.length; i++) {
                  if (items[i].label === values[j]) {
                    editor.jqxDropDownList('checkIndex', i);
                  }
                }
              }
              editor.on('close', (event) => {
                var items = editor.jqxDropDownList('getCheckedItems');
                var itemsLabel = '';
                for (var i = 0; i < items.length; i++) {
                  if (!itemsLabel) {
                    itemsLabel = items[i].value;
                  } else {
                    itemsLabel += ',' + items[i].value;
                  }
                }
                //this.currencyPriorityGrid.setcellvalue(rowid, 'priorityValues', itemsLabel);
                this.currencyValueList[rowid] = itemsLabel;
              });
            }
          }],
        renderstatusbar: (statusbar: any) => {
          this.gridService.RenderStatusBar(statusbar, source);
        }
      };
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/rules/netting/netting.component.ts